import React, { useEffect, useState } from 'react';
import { FiAlertTriangle, FiCheckCircle, FiInfo, FiTrash2 } from 'react-icons/fi';

function AdminDialog({ message, title, onConfirm, onCancel, isAlert, type }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 10); }, []);

  const close = (result) => {
    setVisible(false);
    setTimeout(() => (result ? onConfirm() : onCancel()), 150);
  };

  const isDelete  = type === 'delete';
  const isSuccess = type === 'success';
  const isError   = type === 'error';
  const isInfo    = !isDelete && !isSuccess && !isError;

  const iconBg    = isDelete || isError ? '#fef2f2' : isSuccess ? '#f0fdf4' : '#eff6ff';
  const iconColor = isDelete || isError ? '#ef4444' : isSuccess ? '#22c55e' : '#3b82f6';
  const IconComp  = isDelete ? FiTrash2 : isSuccess ? FiCheckCircle : isError ? FiAlertTriangle : FiInfo;
  const btnBg     = isDelete || isError ? '#ef4444' : isSuccess ? '#22c55e' : '#111111';
  const btnLabel  = isAlert ? 'OK' : isDelete ? 'Delete' : 'Confirm';
  const heading   = title || (isDelete ? 'Delete' : isError ? 'Error' : isSuccess ? 'Success' : 'Confirm');

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) close(false); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 99999,
        background: 'rgba(15,23,42,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backdropFilter: 'blur(4px)',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.15s ease',
        padding: 16,
      }}
    >
      <div style={{
        background: '#fff',
        borderRadius: 18,
        padding: '24px 24px 20px',
        maxWidth: 380,
        width: '100%',
        boxShadow: '0 24px 64px rgba(0,0,0,0.22), 0 4px 16px rgba(0,0,0,0.1)',
        transform: visible ? 'scale(1) translateY(0)' : 'scale(0.92) translateY(16px)',
        transition: 'transform 0.2s cubic-bezier(0.34,1.56,0.64,1)',
      }}>
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 20 }}>
          <div style={{ width: 42, height: 42, borderRadius: 12, background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <IconComp size={20} color={iconColor} />
          </div>
          <div style={{ paddingTop: 2 }}>
            <p style={{ margin: 0, fontWeight: 700, fontSize: '.9rem', color: '#0f172a', marginBottom: 5 }}>{heading}</p>
            <p style={{ margin: 0, fontSize: '.83rem', color: '#64748b', lineHeight: 1.6 }}>{message}</p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {!isAlert && (
            <button onClick={() => close(false)} style={{ padding: '8px 20px', borderRadius: 9, border: '1.5px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: '.83rem', fontWeight: 600, color: '#475569', transition: 'background .15s' }}
              onMouseEnter={e => e.target.style.background = '#f8fafc'}
              onMouseLeave={e => e.target.style.background = '#fff'}
            >Cancel</button>
          )}
          <button onClick={() => close(true)} style={{ padding: '8px 22px', borderRadius: 9, border: 'none', cursor: 'pointer', fontSize: '.83rem', fontWeight: 700, background: btnBg, color: '#fff', transition: 'opacity .15s' }}
            onMouseEnter={e => e.target.style.opacity = '0.85'}
            onMouseLeave={e => e.target.style.opacity = '1'}
          >{btnLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default AdminDialog;
